"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var Settings = require("./settings");
var base = "https://skiliko.firebaseio.com/translations";
var path = "collection/countries.json";
var sort = function (countries) {
    var transform = function (code) {
        return { code: code, name: countries[code] };
    };
    return Object.keys(countries)
        .map(transform)
        .sort(function (c1, c2) { return c1.name.localeCompare(c2.name); });
};
var all = function (locale) {
    var url = [
        base,
        locale || Settings.get("locale") || "en",
        path,
    ].join("/");
    return axios_1.default(url)
        .then(function (response) { return response.data; })
        .then(function (countries) { return sort(countries); });
};
exports.all = all;
var codes = function (locale) {
    return all(locale)
        .then(function (countries) { return countries.map(function (e) { return e.code; }); });
};
exports.codes = codes;
//# sourceMappingURL=country.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/country.js
// module id = 906
// module chunks = 3